export function Ico24File({ ...props }: React.ComponentProps<"svg">) {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.70786 10.1258L10.1261 4.80924C11.3479 3.88766 12.5769 3.4452 13.8005 3.50542C15.3422 3.58221 16.5424 4.15296 17.5612 5.08938C18.5998 6.04411 19.2718 7.40641 19.2718 9.05757C19.2718 10.3247 18.8926 11.4401 18.0922 12.4297L10.4531 20.0746C9.68048 20.6899 8.82161 20.9874 7.90165 20.9517C6.73374 20.9045 5.86499 20.538 5.21904 19.9175C4.4626 19.1923 3.99902 18.3013 3.99902 17.103C3.99902 16.15 4.33772 15.2704 5.03667 14.4448L11.7603 7.77643C12.2993 7.2179 12.8267 6.88628 13.3657 6.80599C13.7255 6.75125 14.0936 6.78265 14.438 6.89748C14.7824 7.0123 15.0928 7.20707 15.3422 7.46488C15.8201 7.95621 16.0249 8.56885 15.9531 9.26614C15.9037 9.74177 15.7033 10.1799 15.335 10.5996L9.15402 16.7505"
        stroke="#1B1B1D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
